
import { defineComponent, PropType } from '@vue/composition-api';
import IllinoisTabBar from '../TabBar.vue';
import {
  LiveEventDetailsEvent,
  LiveEventsEvent,
  LivescoreStatisticsItem
} from '../../../../../types/sport';
import CornerRedYellow from './CornerRedYellow.vue';
import IllinoisTimeline from '../Timeline/Timeline.vue';
import IncidentsCodes from '../../IncidentsCodes.json';
import StatsGraph from './StatsGraph.vue';
import { TabItem } from '../../../../../types/components';
const incidentsCodes = IncidentsCodes;

export default defineComponent({
  name: 'FieldStatistics',
  components: {
    IllinoisTabBar,
    CornerRedYellow,
    IllinoisTimeline,
    StatsGraph
  },

  data() {
    return {
      fieldTab: window.innerWidth < 768 ? 'field' : 'statistics',
      urlCloudfront:
        process.env.VUE_APP_URL_CLOUDFRONT + '/illinoisSlider/event-bg.webp',
      segments: [
        { value: 21, colorVar: '--secondary-color' },
        { value: 80, colorVar: '--primary-color' }
      ],

      incidentsCodes: incidentsCodes as Record<
        string | number,
        Record<string, string>
      >,
      aggregatedStatisticsTypes: [1, 6, 7] as number[],
      viewportWidth: window.innerWidth
    };
  },
  props: {
    tabbarItems: {
      type: Array as PropType<TabItem[]>,
      required: true
    }
  },
  computed: {
    sportId(): string | number {
      return this.$store.getters['IllinoisSport/getFieldStatisticsSportId'];
    },
    eventId(): string | number {
      return this.$store.getters['IllinoisSport/getFieldStatisticsEventId'];
    },
    event(): LiveEventDetailsEvent | LiveEventsEvent | null {
      if (this.eventId) {
        const fromById = this.$store.getters['IllinoisSport/getLiveEventById'](
          this.eventId
        );
        return (fromById && fromById.event) || null;
      }
      console.log('sportId', this.sportId);
      const fromBySport = this.$store.getters[
        'IllinoisSport/getLiveEventsBySport'
      ](this.sportId || '');
      const firstEvent = fromBySport?.groupedEvents?.[0]?.[0] || null;
      console.log('firstEvent', firstEvent);
      return firstEvent as LiveEventsEvent | null;
    },
    statistics(): LivescoreStatisticsItem[] {
      return (this.event?.livescore?.Statistics ??
        []) as LivescoreStatisticsItem[];
    },
    aggregatedStatistics(): LivescoreStatisticsItem[] {
      return this.statistics.filter(stat =>
        this.aggregatedStatisticsTypes.includes(Number(stat.Type))
      );
    },
    individualStatistics(): LivescoreStatisticsItem[] {
      return this.statistics.filter(
        stat => !this.aggregatedStatisticsTypes.includes(Number(stat.Type))
      );
    }
  }
});
